export default __webpack_public_path__ + "static/media/dr-avatar.5d6a8199.png";